export const UserRoles = {
  AccountManager: 4,
  RoimaticUser: 15,
  BrandManager: 16,
  ClientAccess: 27,
  UplocalAffliateAdmin: 36,
  UplocalAffiliateClientAccess: 37
}